import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import CircularProgress from "@mui/material/CircularProgress";

import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RoomIcon from "@mui/icons-material/Room";

import AliceCarousel from "react-alice-carousel";
import {TabPanelProduct} from "./TabPanelProduct";
import {BasketComponent} from "../../BasketComponent";
import PositionedMenu from "../../PositionedMenu";
import {ProductComponentSetareh} from "./ProductComponentSetareh";
import {BASE_URL_API, MARKET_BASE_URL_API} from "../../../Const";

export class ProductCollectionComponentSetareh extends React.Component {
    appBarRef = React.createRef();
    tabsRef = React.createRef();

    // NEW: wrapper ref for the sticky Tabs container
    topTabsWrapRef = React.createRef();

    scrollerEl = null;

    // touch/scroll guards
    isTouchingTabs = false;
    isDraggingTabs = false;
    touchStartX = 0;
    lastTabsScrollLeft = 0;
    resizeRaf = 0;
    freezeSnapUntil = 0; // timestamp (ms)

    constructor(props) {
        super(props);
        this.state = {
            // ── data ────────────────────────────────────────────────────────────────
            marketInfo: {},
            parents: [], // top-level categories
            subcatsByParent: {}, // { [parentId]: Category[] }
            // ── render control ─────────────────────────────────────────────────────
            splashVisible: true,
            headerHeight: 0,
            tabsHeight: 0, // NEW: measured sticky Tabs wrapper height
            // top tabs
            panelValue: 0, // drives main content panels
            tabsValue: 0, // selected top tab; -1 while user dragging
            // nested sub tabs
            subTabIndexByParent: {}, // remember per parent (default 0 = "All")
            // optional filtering mode (kept)
            filteredParents: null,
            open: false,
            popUpOpen: false,
        };
    }

    // ───────────────────────────────────────────────────────────────────────────
    // lifecycle
    async componentDidMount() {
        this.attachScroller();
        window.addEventListener("resize", this.onWindowResize, {passive: true});

        const started = Date.now();
        const minSplash = 1000;

        const token = localStorage.getItem("pwa_token");
        const headers = {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        };

        // Market
        const pMarket = fetch(BASE_URL_API + "market/" + this.props.id, {headers})
            .then((r) => r.json())
            .then((res) => {
                if (res?.code === 200)
                    this.setState({marketInfo: res.data || {}}, this.measureHeader);
            })
            .catch((e) => console.log("market error", e));

        // Categories
        const pCats = fetch(
            BASE_URL_API + "subCategory?market_id=" + this.props.id,
            {headers}
        )
            .then((r) => r.json())
            .then((res) => {
                const all = Array.isArray(res?.data) ? res.data : [];

                // Normalize: ensure string ids for safe comparison
                const norm = all.map((c) => ({
                    ...c,
                    id: String(c.id),
                    parent_id:
                        c.parent_id != null
                            ? String(c.parent_id)
                            : c.parentId != null
                            ? String(c.parentId)
                            : null,
                    title: c.title ?? c.name ?? "",
                }));

                // Detect parents/children:
                const hasChildren = norm.some(
                    (c) => Array.isArray(c.children) && c.children.length
                );
                let parents = [];
                let subcatsByParent = {};

                if (hasChildren) {
                    parents = norm;
                    subcatsByParent = parents.reduce((acc, p) => {
                        const kids = Array.isArray(p.children)
                            ? p.children.map((k) => ({
                                ...k,
                                id: String(k.id),
                                parent_id: String(p.id),
                                title: k.title ?? k.name ?? "",
                            }))
                            : [];
                        acc[String(p.id)] = kids;
                        return acc;
                    }, {});
                } else {
                    // Flat list with parent_id
                    const candidates = norm.filter(
                        (c) => !c.parent_id || c.parent_id === "0"
                    );
                    if (candidates.length > 0) {
                        parents = candidates;
                    } else {
                        const pids = new Set(norm.map((c) => c.parent_id).filter(Boolean));
                        parents = [...pids].map((pid) => {
                            const fromList = norm.find((c) => c.id === pid);
                            return (
                                fromList || {id: pid, title: "دسته " + pid, parent_id: null}
                            );
                        });
                    }
                    subcatsByParent = parents.reduce((acc, p) => {
                        const pid = String(p.id);
                        acc[pid] = norm.filter((c) => c.parent_id === pid);
                        return acc;
                    }, {});
                }

                // Respect incoming filter (if any)
                const incoming =
                    Array.isArray(this.props.initialCategories) &&
                    this.props.initialCategories.length > 0
                        ? this.props.initialCategories.map(String)
                        : this.props.initialCategory
                        ? [String(this.props.initialCategory)]
                        : [];

                if (incoming.length > 0) {
                    const idSet = new Set(incoming);
                    const subset = parents.filter((p) => idSet.has(String(p.id)));
                    if (subset.length > 0) {
                        this.setState(
                            {
                                parents,
                                subcatsByParent,
                                filteredParents: subset,
                                panelValue: 0,
                                tabsValue: 0,
                            },
                            this.measureHeader
                        );
                        return;
                    }
                }

                this.setState(
                    {
                        parents,
                        subcatsByParent,
                        filteredParents: null,
                        panelValue: 0,
                        tabsValue: 0,
                    },
                    this.measureHeader
                );
            })
            .catch((e) => console.log("category error", e));

        await Promise.all([pMarket, pCats]);

        const elapsed = Date.now() - started;
        const delay = Math.max(0, minSplash - elapsed);
        setTimeout(() => this.setState({splashVisible: false}), delay);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onWindowResize);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.filteredParents !== this.state.filteredParents ||
            prevState.parents.length !== this.state.parents.length
        ) {
            this.measureHeader();
        }
        if (!this.scrollerEl) this.attachScroller();
    }

    // ───────────────────────────────────────────────────────────────────────────
    // touch handling for top tabs scroller
    onTabsTouchStart = (e) => {
        this.isTouchingTabs = true;
        this.isDraggingTabs = false;
        this.touchStartX = e.touches?.[0]?.clientX ?? 0;
        if (this.scrollerEl) this.lastTabsScrollLeft = this.scrollerEl.scrollLeft;
    };

    onTabsTouchMove = (e) => {
        if (!this.isTouchingTabs) return;
        const x = e.touches?.[0]?.clientX ?? 0;
        const dx = Math.abs(x - this.touchStartX);
        if (!this.isDraggingTabs && dx > 8) {
            this.isDraggingTabs = true;
            if (this.state.tabsValue !== -1) this.setState({tabsValue: -1});
        }
    };

    onWindowResize = () => {
        const now = Date.now();
        if (
            this.scrollerEl &&
            (this.state.tabsValue === -1 || now < this.freezeSnapUntil)
        ) {
            this.scrollerEl.scrollLeft = this.lastTabsScrollLeft;
            return;
        }
        this.measureHeader();
    };

    attachScroller() {
        const tabsNode = this.tabsRef.current;
        if (!tabsNode) return;
        const scroller = tabsNode.querySelector(".MuiTabs-scroller");
        if (!scroller) return;
        this.scrollerEl = scroller;
        Object.assign(this.scrollerEl.style, {
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
            touchAction: "pan-x",
            overscrollBehaviorX: "contain",
            scrollBehavior: "auto",
        });
    }

    measureHeader = () => {
        cancelAnimationFrame(this.resizeRaf);
        this.resizeRaf = requestAnimationFrame(() => {
            const headerH = Math.round(this.appBarRef.current?.offsetHeight || 0);
            const tabsH = Math.round(this.topTabsWrapRef.current?.offsetHeight || 0); // NEW
            const needUpdate =
                headerH !== this.state.headerHeight || tabsH !== this.state.tabsHeight;
            if (needUpdate) {
                this.setState({headerHeight: headerH, tabsHeight: tabsH});
            }
        });
    };

    // ───────────────────────────────────────────────────────────────────────────
    // handlers
    handleTopChange = (_e, newValue) => {
        // reset visual & content index
        this.setState({panelValue: newValue, tabsValue: newValue}, () => {
            // ensure subtab has a default (0 = All) for new parent
            const parent = this.getParents()[newValue];
            if (parent) {
                const pid = String(parent.id);
                this.setState((prev) => ({
                    subTabIndexByParent: {
                        ...prev.subTabIndexByParent,
                        [pid]: prev.subTabIndexByParent[pid] ?? 0,
                    },
                }));
            }
        });
    };

    handleSubChange = (parentId) => (_e, newIdx) => {
        this.setState((prev) => ({
            subTabIndexByParent: {...prev.subTabIndexByParent, [String(parentId)]: newIdx},
        }));
    };

    // helpers
    getParents() {
        const {filteredParents, parents} = this.state;
        return Array.isArray(filteredParents) ? filteredParents : parents;
    }

    getSubcats(parent) {
        if (Array.isArray(parent?.children) && parent.children.length) {
            return parent.children;
        }
        const {subcatsByParent} = this.state;
        return subcatsByParent[String(parent.id)] || [];
    }

    // ───────────────────────────────────────────────────────────────────────────
    // splash
    renderSplash() {
        const {splashVisible, marketInfo} = this.state;
        const cover = marketInfo?.pictures?.[0]?.url
            ? MARKET_BASE_URL_API + marketInfo.pictures[0].url
            : null;

        return (
            <Backdrop
                open={splashVisible}
                sx={{
                    zIndex: (t) => t.zIndex.modal + 9999,
                    bgcolor: "rgba(243, 244, 246, 0.85)",
                    backdropFilter: "blur(3px)",
                }}
            >
                <Fade in={splashVisible} timeout={{enter: 350, exit: 250}}>
                    <Box
                        sx={{
                            bgcolor: "#fff",
                            borderRadius: 3,
                            boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
                            p: 3,
                            width: 320,
                            textAlign: "center",
                            fontFamily: "RokhFaNum, Arial, sans-serif",
                        }}
                    >
                        <Box
                            component="img"
                            src={cover || undefined}
                            alt=""
                            sx={{
                                width: 220,
                                height: 150,
                                objectFit: "cover",
                                borderRadius: 2,
                                mx: "auto",
                                mb: 2,
                                display: cover ? "block" : "none",
                            }}
                        />
                        <Typography
                            variant="h6"
                            sx={{mb: 1, fontWeight: 800, color: "#222", direction: "rtl"}}
                        >
                            {marketInfo?.name || "در حال بارگذاری فروشگاه"}
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 1,
                            }}
                        >
                            <CircularProgress size={22} thickness={5} sx={{color: "#9a1111"}}/>
                            <Typography variant="body2" sx={{color: "#555"}}>
                                لطفاً صبر کنید…
                            </Typography>
                        </Box>
                    </Box>
                </Fade>
            </Backdrop>
        );
    }

    renderCarouselAndAbout(marketInfo) {
        return (
            <AliceCarousel
                autoPlay
                autoPlayStrategy="none"
                autoPlayInterval={2500}
                animationDuration={1000}
                infinite
                touchTracking={false}
                disableButtonsControls
                disableDotsControls
            >
                {marketInfo.pictures?.map((item, index) => (
                    <div
                        key={index}
                        style={{display: "flex", justifyContent: "center", padding: "8px 0"}}
                    >
                        <div
                            style={{
                                width: "100%",
                                aspectRatio: "1 / 1",
                                height: 280,
                                borderRadius: 24,
                                overflow: "hidden",
                                background: "#fff",
                                border: "1px solid rgba(0,0,0,0.06)",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                            }}
                        >
                            <img
                                src={MARKET_BASE_URL_API + item.url}
                                alt=""
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block",
                                }}
                            />
                        </div>
                    </div>
                ))}
            </AliceCarousel>
        );
    }

    // ───────────────────────────────────────────────────────────────────────────
    render() {
        const {id} = this.props;
        const {
            marketInfo,
            panelValue,
            tabsValue,
            headerHeight,
            tabsHeight,
            subTabIndexByParent,
        } = this.state;

        const parents = this.getParents();
        const activeParent = parents[panelValue];
        const activeParentId = activeParent ? String(activeParent.id) : null;
        const subcats = activeParent ? this.getSubcats(activeParent) : [];
        const subIndex = activeParentId
            ? subTabIndexByParent[activeParentId] ?? 0
            : 0;

        return (
            <div
                style={{
                    backgroundColor: "#d3d6db",
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Header */}
                <AppBar
                    ref={this.appBarRef}
                    color="transparent"
                    elevation={0}
                    position="fixed"
                    sx={{
                        direction: "rtl",
                        zIndex: (t) => t.zIndex.modal + 2,
                        background: "transparent",
                        boxShadow: "none",
                        p: 0,
                        m: 0,
                    }}
                >
                    <Box
                        sx={{
                            mx: 1,
                            mt: 1,
                            mb: 0,
                            p: 0,
                            borderRadius: 3,
                            bgcolor: "common.white",
                            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                            overflow: "hidden",
                        }}
                    >
                        <ToolbarMui
                            disableGutters
                            sx={{
                                minHeight: 40,
                                px: 1.5,
                                gap: 1,
                                justifyContent: "space-between",
                            }}
                        >
                            <Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                                <PositionedMenu marketInfo={marketInfo}/>
                            </Box>

                            <ListItemText
                                primary={
                                    <strong
                                        style={{
                                            fontFamily: "RokhFaNum, Arial, sans-serif",
                                            fontSize: 16,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            color: "#222",
                                        }}
                                    >
                                        {marketInfo.name}
                                    </strong>
                                }
                                sx={{textAlign: "center", mx: 1}}
                            />

                            <Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                                <IconButton sx={{color: "text.primary"}}>
                                    <BasketComponent/>
                                </IconButton>
                            </Box>
                        </ToolbarMui>
                    </Box>
                </AppBar>

                <Box sx={{flex: 1, display: "flex", flexDirection: "column"}}>
                    {/* Spacer below fixed header */}
                    <div style={{height: headerHeight + 5}}/>

                    {/* ── Top Tabs (Parents) — now sticky under AppBar ─────────────── */}
                    <Box
                        ref={this.topTabsWrapRef}
                        sx={{
                            position: "sticky",
                            top: `${headerHeight}px`,
                            zIndex: (t) => t.zIndex.appBar + 1,
                            backgroundColor: "#d3d6db",
                            pb: 1,
                        }}
                    >
                        <Tabs
                            ref={this.tabsRef}
                            value={tabsValue}
                            onChange={this.handleTopChange}
                            variant="scrollable"
                            selectionFollowsFocus={false}
                            TabIndicatorProps={{
                                style: tabsValue === -1 ? {display: "none"} : undefined,
                            }}
                            sx={{
                                direction: "rtl",
                                "& .MuiTabs-scroller": {
                                    direction: "rtl",
                                    overflowX: "auto !important",
                                    WebkitOverflowScrolling: "touch",
                                    touchAction: "pan-x",
                                    overscrollBehaviorX: "contain",
                                    px: 1,
                                    scrollPaddingInline: "8px",
                                },
                                "& .MuiTabs-flexContainer": {
                                    minHeight: 48,
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    gap: 1,
                                },
                                "& .MuiTabs-indicator": {display: "none"},
                                "& .MuiTab-root": {
                                    fontFamily: "RokhFaNum, Arial, sans-serif",
                                    fontWeight: "bold",
                                    fontSize: "0.95rem",
                                    color: "#444",
                                    borderRadius: "16px",
                                    border: "1px solid #ccc",
                                    backgroundColor: "#fff",
                                    minHeight: 36,
                                    minWidth: "auto",
                                    padding: "6px 16px",
                                    margin: "4px 2px",
                                    textAlign: "center",
                                    transition: "all 0.2s ease",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                    "&:hover": {backgroundColor: "#f7f7f7"},
                                    "&.Mui-selected": {
                                        backgroundColor: "#9a1111",
                                        color: "#fff",
                                        borderColor: "#9a1111",
                                        fontWeight: 900,
                                        boxShadow: "0 3px 8px rgba(154,17,17,0.3)",
                                    },
                                },
                            }}
                            style={{marginBottom: 0}}
                            onTouchStart={this.onTabsTouchStart}
                            onTouchMove={this.onTabsTouchMove}
                        >
                            {parents.map((p, i) => (
                                <Tab key={p.id} label={p.title} value={i}/>
                            ))}
                        </Tabs>
                    </Box>

                    {/* ── Panels (per top parent) ───────────────────────────────────── */}
                    {parents.map((parent, pi) => {
                        const pid = String(parent.id);
                        const children = this.getSubcats(parent);
                        const subIdx = this.state.subTabIndexByParent[pid] ?? 0;

                        // Decide which category_id to pass:
                        const effectiveCategoryId =
                            subIdx === 0 ? parent.id : children[subIdx - 1]?.id ?? parent.id;

                        return (
                            <TabPanelProduct
                                key={pid}
                                value={this.state.panelValue}
                                index={pi}
                                style={{padding: 0, margin: 0}}
                            >
                                <ProductComponentSetareh
                                    key={`cat-${pid}-${effectiveCategoryId}`}
                                    market_id={id}
                                    category_id={effectiveCategoryId}
                                    main_category={parent.title}
                                    market_name={marketInfo.name}
                                    // NEW: pass the total sticky offset so inner chips bar stacks under the Tabs
                                    stickyOffset={headerHeight + tabsHeight}
                                />
                            </TabPanelProduct>
                        );
                    })}
                </Box>

                {/* Footer Info Box */}
                <Box
                    sx={{
                        mt: 2,
                        mx: "auto",
                        maxWidth: "80%",
                        borderRadius: "24px 24px 0 0",
                        bgcolor: "#fff",
                        boxShadow: "0 -3px 15px rgba(0,0,0,0.08)",
                        p: 2.5,
                        textAlign: "center",
                        direction: "rtl",
                        fontFamily: "RokhFaNum, Arial, sans-serif",
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            fontSize: 14,
                            color: "#333",
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                            mb: 2,
                            lineHeight: 1.7,
                        }}
                    >
                        <strong>{marketInfo.content}</strong>
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 2,
                            color: "#444",
                            fontSize: 13,
                        }}
                    >
                        {marketInfo.phone && (
                            <Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                                <PhoneIcon sx={{fontSize: 18, color: "#9a1111"}}/>
                                <Typography variant="body2" sx={{fontWeight: 500}}>
                                    {marketInfo.phone}
                                </Typography>
                            </Box>
                        )}

                        {marketInfo.whatsapp && (
                            <Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                                <WhatsAppIcon sx={{fontSize: 20, color: "#25D366"}}/>
                                <a
                                    href={`https://wa.me/${marketInfo.whatsapp}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{textDecoration: "none", color: "#25D366", fontWeight: 600}}
                                >
                                    WhatsApp
                                </a>
                            </Box>
                        )}

                        {marketInfo.address && (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    maxWidth: 260,
                                }}
                            >
                                <RoomIcon sx={{fontSize: 18, color: "#9a1111"}}/>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                    title={marketInfo.address}
                                >
                                    {marketInfo.address}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>

                {/* Splash Overlay */}
                {this.renderSplash()}
            </div>
        );
    }
}

ProductCollectionComponentSetareh.defaultProps = {
    initialCategories: [],
    initialCategory: undefined,
};
